import { Injectable, signal } from '@angular/core';

/** Tab IDs that are valid for the settings dialog URL (must match SettingsDialogComponent tabs). */
export const SETTINGS_TAB_IDS = [
  'account',
  'setup',
  'addons',
  'document-generation',
  'appearance',
  'credits',
  'sources',
  'language',
  'referrals',
  'userAdministration',
  'billing',
  'security',
  'alerts',
] as const;

export type SettingsTabId = (typeof SETTINGS_TAB_IDS)[number];

/** Connector config sub-views in the settings sidebar (?settings=integration:<connectorId>). */
export const CONNECTOR_CONFIG_TAB_PREFIX = 'integration:';

@Injectable({ providedIn: 'root' })
export class SettingsDialogStateService {
  /** Whether the settings dialog is currently open (used to avoid opening twice from URL). */
  readonly isOpen = signal(false);

  setOpen(value: boolean): void {
    this.isOpen.set(value);
  }

  isValidTabId(id: string): id is SettingsTabId {
    return (SETTINGS_TAB_IDS as readonly string[]).includes(id);
  }

  /** Top-level tabs plus booked-connector config sub-views (not the Add-ons catalog tab). */
  isOpenableTabId(id: string): boolean {
    return this.isValidTabId(id) || id.startsWith(CONNECTOR_CONFIG_TAB_PREFIX);
  }
}
